const apiUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://api.forumurbano.pt/'
    : 'http://0.0.0.0:1337/';

const dummyDelay = (ms) => new Promise((res) => setTimeout(res, ms));

// GET /projects/code/:code
//           sem body
// PUT /projects/code
//            body { "codigo": "h632h4f2tc000000",  "EmailContacto": "cuaralho@hotmail.com", ...outros_campos_para_update }
// POST /projects
//       body: {...campos}
export async function postNewSubmission(proposal) {
  console.log('About to POST: ', proposal);
  // POST request using fetch with async/await
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(proposal)
  };
  const response = await fetch(apiUrl + 'projects', requestOptions);
  const data = await response.json();
  //console.log('ANSWER FROM API:', data);
  return data;
}
export async function postEditedSubmission(proposal) {
  // POST request using fetch with async/await
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(proposal) //needs a code on body
  };
  const response = await fetch(apiUrl + 'projects/code', requestOptions);
  const data = await response.json();
  // console.log('ANSWER FROM API:', data);
  return data;
}

export async function getProjectWithCode(code, email) {
  await dummyDelay(500);

  let dummyProject = {
    'morada entidade': 'Rua Gonçalo Nunes, 20, R/C C 1400-415 Lisboa',
    'Email contacto': 'fabioguedes_93@hotmail.com',
    'Nome contacto': 'Fábio Guedes',
    'descrição proposta':
      'O projeto trabalha com idosos e procura a sua integração e melhoria da qualidade de vida, promovendo o envelhecimento activo, a autonomia e a participação social. Face ao estado de pandemia, adaptou-se o Plano de Execução, mantendo os seus eixos centrais:1. SaudavelMente- Aconselhamento psicológico2.GinasticaMente (Estimulação/Reabilitação cognitiva)3.Cuidar de Quem Cuida! (Workshops e formações para idosos, cuidadores formais e informais)',
    'Quem sou Titulo': 'InterAjuda',
    'Quem sou': 'Proj 11/2019 - InterAjuda',
    'Nome entidades': [
      'Aventura Social',
      'Ass. Bombeiros Voluntários da Ajuda',
      'C.S.P. Nª Sª da Ajuda'
    ],
    '#Bip/Zip': ['1', '63'],
    'descrição proposta__1': [
      'SaudavelMente - Aconselhamento psicológico: Manter acompanhamentos por Skype e/ou telefoneGinasticaMente - Caderno de exercícios distribuído pelos participantes, para realizarem no domicílioCuidar de Quem Cuida - Workshops online abertos à comunidade; - Colocar desafios/informação para promover debate e reflexão.'
    ],
    'info útil': ['Via Skype e Presencialmente'],
    'objectivo e relevância': [
      'Adaptação do projeto às circuntâncias da pandemia, dando resposta à população Sénior dos territórios 1 e 63.'
    ],
    'áreas temáticas': ['Saúde'],
    'Respostas COVID': [
      'Saúde em casa',
      'atividade e bem estar fisico',
      'apoio Saúde mental',
      'Apoio ao estudo e formação online'
    ],
    'lista acções': [
      'partilha de experiências e informação',
      'informação sobre saúde',
      'Formação Online',
      'aconselhamento psicológico',
      'acompanhamento diárias aos grupos vulneráveis',
      'planos de atividade física em casa'
    ],
    'Como Podemos Ajudar': [
      'https://www.facebook.com/ProjetoInterAjuda/?epa=SEARCH_BOX'
    ],
    'Fonte da Informação': ['Promotora do Projeto.'],
    'Lista de Destinatários': [''],
    'telefone contacto (não obrigatório)': ['924371311'],
    DISPONIBILIZO: ['Recursos Humanos', 'Serviços'],
    'descrição recursos disponiveis': [
      'Apoio na psicológico no âmbito da saúde mental na área da Ajuda'
    ],
    NECESSITO: ['Serviços'],
    'descrição recursos necessita': [
      'Divulgação dos WS para cuidadores formais e informais'
    ],
    FREGUESIA: ['Ajuda'],
    populacao: ['1,484', '2,962'],
    nomeBairroBipZip: ['Casalinho da Ajuda', 'Rio Seco'],
    meta: {
      revision: 0,
      created: 1620654818667,
      version: 0
    },
    $loki: 1
  };
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
    // body: JSON.stringify(proposal) //needs a code on body
  };

  const response = await fetch(
    apiUrl + 'projects/code/' + code + '/' + email,
    requestOptions
  );
  //console.log('ANSWER response:', response);

  if (response.status !== 200) {
    return { error: 'nope', status: response.status };
  }
  const data = await response.json();

  return data;

  // return dummyProject;
}
export async function getAllProjects() {
  // POST request using fetch with async/await
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
    // body: JSON.stringify(proposal)
  };
  const response = await fetch(apiUrl + 'projects', requestOptions);
  const data = await response.json();
  //console.log('ANSWER FROM API:', data);
  return data;
}
